import { render, staticRenderFns } from "./FindRec.vue?vue&type=template&id=4aeb4563&"
import script from "./FindRec.vue?vue&type=script&lang=js&"
export * from "./FindRec.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports